const CUI_LABEL = "CIF / CUI";
const CUI_DETAILED_LABEL = "Cod identificare fiscală";
const REGISTER_NUM_LABEL = "Nr. înregistrare registrul comerțului";
const ADDRESS_LABEL = "Adresa";
const CHECKBOX_LABEL =
  "Adresa de corespondență este aceeași cu cea a sediului social";
const CITY_LABEL = "Oraș / Sector";
const POSTAL_CODE_LABEL = "Cod poștal*";
const COUNTY_LABEL = "Județ";
const APPELLATIVE_LABEL = "Apelativ";
const POSITION_LABEL = "Poziția în cadrul companiei";
const FIRST_NAME_LABEL = "Prenume*";
const LAST_NAME_LABEL = "Nume*";
const EMAIL_LABEL = "E-mail*";
const PHONE_LABEL = "Telefon*";
const IBAN_LABEL = "Cont IBAN";
const BANK_LABEL = "Deschis la banca";
const DATE_LABEL = "Data contractului";
const AMOUNT_LABEL = "Suma din contract (lei)";
const INITIAL_LETTER_FATHER_LABEL = "Iinițiala tatălui*";
const STREET_LABEL = "Stradă*";
const NUMBER_LABEL = "Număr*";
const BUILDING_LABEL = "Bloc";
const ENTRANCE_LABEL = "Scară";
const FLOOR_LABEL = "Etaj";
const APARTMENT_LABEL = "Apartament";
const COUNTY_SECTOR_LABEL = "Județ/Sector*";
const LOCALITY_LABEL = "Localitate*";
const IDENTITY_NUMBER_LABEL = "Cod numeric personal / Număr de identificare fiscală*";
const SIGNATURE_LABEL = "Semnează aici*";
const CHECKBOX_CONTRACT_PERIOD_LABEL = "Opțiune privind distribuirea sumei pentru o perioadă de 2 ani";

export {
  CHECKBOX_CONTRACT_PERIOD_LABEL,
  SIGNATURE_LABEL,
  INITIAL_LETTER_FATHER_LABEL,
  STREET_LABEL,
  NUMBER_LABEL,
  BUILDING_LABEL,
  ENTRANCE_LABEL,
  FLOOR_LABEL,
  APARTMENT_LABEL,
  COUNTY_SECTOR_LABEL,
  LOCALITY_LABEL,
  IDENTITY_NUMBER_LABEL,
  CUI_LABEL,
  CUI_DETAILED_LABEL,
  REGISTER_NUM_LABEL,
  ADDRESS_LABEL,
  CHECKBOX_LABEL,
  CITY_LABEL,
  POSTAL_CODE_LABEL,
  COUNTY_LABEL,
  APPELLATIVE_LABEL,
  POSITION_LABEL,
  FIRST_NAME_LABEL,
  LAST_NAME_LABEL,
  EMAIL_LABEL,
  PHONE_LABEL,
  IBAN_LABEL,
  BANK_LABEL,
  DATE_LABEL,
  AMOUNT_LABEL
};
